export enum TypesErrors {
  GENERIC_ERROR,
  PAYMENT_ERROR_RETRY,
  PAYMENT_ERROR_COUNTER,
  UNACCOMPANIED_MINOR,
  CREDIT_CARD_READ_ERROR,
  PASSPORT_SCAN_ERROR,
  RESERVATION_NOT_FOUND,
  RESERVATION_PNR_NOT_FOUND,
  UNABLE_TO_REMOVE_ITEM,
  TOO_LATE_FOR_CHECKIN,
  TOO_EARLY_FOR_CHECKIN,
  FLIGHT_NOT_OPERATED_BY_AM,
  CREDIT_CARD_DECLINED,
  CREDIT_CARD_HOST_ERROR,
  CHECKIN_ERROR,
  CHECKIN_OVI_ERROR,
  CHECKIN_OVS_ERROR,
  CHECKIN_ABOVE_AUTHORIZATION_ERROR,
  LOAD_BALANCER,
  TIMEOUT_ERROR,
  SCAN_PASSPORT_ERROR,
  PINPAD_NOT_READY_ERROR,
  TSA_VALIDATION,
  PNR_LOOKUP_FAILURE,
  PAID_SEAT_AT_COUNTER,
  NO_ELIGIBLE_PASSENGERS,
  STATIC_PROFILE_UPDATE,
  PROFILE_UPDATE,
  PP_SCAN_FAIL,
  DEST_SEARCH_FAIL,
  FLIGHT_SEARCH_FAIL,
  PINPAD_INIT_FAIL,
  MANUALLY_ENTERED_CARD_ERROR,
  EMAIL_ERROR,
  REPRINT_BOARDING_PASSES_ERROR,
  FAILED_TO_RESERVE_PREMIERE_UPGRADE,
  OVERWEIGHT_BAG_CHECKIN_ERROR,
  ALL_SEATS_SELECTED,
  PAYMENT_NOT_SUPPORTED,
  CART_UPDATE_FAILED,
  BAGGAGE_OVERWEIGHT_ERROR,
  AGENT_SCAN_FAILED,
  FREQUENT_FLIER_ERROR,
  START_OVER_AUTH_REQUIRED,
  START_OVER_AUTH_REQUIRED_CANCELLED,
  BAG_TAG_ERROR,
  BAG_TAG_RETRY_WARNING,
  OVER_BOOKING_UPDATE_ERROR,
  OVERBOOKING_CONFIRMATION,
  WARNING_CONECCTION_BAGGAGE,
  PREMIER_TYPE_WITHOUT_BAGGAGE,
  PREMIER_TYPE_WITH_BAGGAGE,
  PREMIER_TYPE_ADD,
  LIMIT_BAGS,
  MAX_BAGGAGE_OVERWEIGHT_LIMIT,
  SEAT_CHANGE_WARN,
  SEATS_REMOVE_CART,
  CHANGUE_FLIGHT_IROPS,
  UPDATE_DOCUMENTS,
  ERROR_IN_REMARK,
  WERE_SORRY_GENERIC,
  BAGGAGE_NO_ELEGIBILITY,
  FARELOCK_ERROR,
  NO_OVERWEIGHT,
  BAGS_CONNECTION_RESTRICTION,
  BAGS_NO_KIOSK_AVAILABLE,
  BAGS_INCLUDED_ONLY_AVAILABLE,
  SSBD_HTTP_503,
  FARE_FAMILY_EMPTY_ERROR,
  NO_ITINERARY,
  BAGS_STANDBY_COUNTER_REQUIRED,
  DEFAULT_ERROR = 99,
}

export enum CodesError {
  RESERVATION_PNR_NOT_FOUND = '206003',
  ETICKET = '22530302',
}

export enum CodesErrorDestination {
  RESERVATION_DESTINATION_NOT_FOUND = '204131',
  RESERVATION_DESTINATION_NOT_FOUND2 = '204131-1',
}

export enum CodesErrorJSON {
  ERROR_FROM_JSON = 'ERROR_FROM_JSON',
}

export enum ResultAlertError {
  ACCEPT = 1,
  CANCEL = 2,
}
